import { gql } from '@/__generated__/gql';

export const ADVISORY_FIRMS_QUERY = gql(`
  query TenantsAdvisoryFirms($data: AdvisoryFirmsInputDto!) {
    advisoryFirms(data: $data) {
      total
      page
      perPage
      data {
        id
        name
        type
        deletedAt
        reportingType
        primaryAdmin {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`);

export const CREATE_TENANT_MUTATION = gql(`
  mutation TenantsCreateTenant($data: CreateTenantDto!) {
    createTenant(data: $data) {
      id
      name
      type
      deletedAt
      primaryAdmin {
        id
        firstName
        lastName
        email
      }
    }
  }
`);

export const EDIT_TENANT_MUTATION = gql(`
  mutation TenantsUpdateTenant($data: UpdateTenantDto!) {
    updateTenant(data: $data) {
      id
      name
      type
      deletedAt
      primaryAdmin {
        id
        firstName
        lastName
        email
      }
    }
  }
`);

export const DELETE_TENANT_MUTATION = gql(`
  mutation TenantsDeleteTenant($data: DeleteTenantDto!) {
    deleteTenant(data: $data) {
      id
      name
      type
      deletedAt
      primaryAdmin {
        id
        firstName
        lastName
        email
      }
    }
  }
`);
